var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { str_replace } from '../../../../utils/helper/helper_string';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class BrowserStylsheet {
    parent;
    name;
    constructor(parent, name) {
        this.parent = parent;
        this.name = name;
    }
    get sheetManager() {
        return this.parent;
    }
    get nativeSheet() {
        return this.sheetManager.nativeStylesheedByName(this.name);
    }
    get isAvailable() {
        return !!this.nativeSheet;
    }
    get rules() {
        if (!this.nativeSheet)
            return [];
        try {
            return Array.from(this.nativeSheet.rules);
        }
        catch (e) {
            console.log(e);
            return [];
        }
    }
    rulesByName() { }
    ensureRevStyle(ruleName) {
        const { rules } = this;
        const revRule = rules.find(rule => rule.selectorText === `.${ruleName}-rev` || rule.name === `${ruleName}-rev`);
        if (!revRule) {
            const rulesToCopy = rules.filter(rule => rule.selectorText === `.${ruleName}` || rule.name === ruleName);
            for (const rule of rulesToCopy) {
                if (rule.type === 1) {
                    this.nativeSheet.insertRule(str_replace(rule.selectorText.substr(1), `${rule.selectorText.substr(1)}-rev`, rule.cssText));
                }
                if (rule.type === 7) {
                    this.nativeSheet.insertRule(str_replace(rule.name, `${rule.name}-rev`, rule.cssText));
                }
            }
        }
    }
}
__decorate([
    memoize
], BrowserStylsheet.prototype, "nativeSheet", null);
